import { PhoneCall, ClipboardList, Boxes, Truck, MapPinned } from "lucide-react";

const STEPS = [
  {
    icon: PhoneCall,
    n: "01",
    title: "Contattaci",
    desc: "Telefono, modulo o WhatsApp. Vi rispondiamo entro 60 minuti.",
  },
  {
    icon: ClipboardList,
    n: "02",
    title: "Sopralluogo",
    desc: "Gratuito, anche in videochiamata. Studiamo ogni dettaglio.",
  },
  {
    icon: Boxes,
    n: "03",
    title: "Imballaggio",
    desc: "Materiali professionali. Tutto protetto, catalogato e etichettato.",
  },
  {
    icon: Truck,
    n: "04",
    title: "Trasporto",
    desc: "Mezzi attrezzati, autoscale, squadre formate. Tutto sotto controllo.",
  },
  {
    icon: MapPinned,
    n: "05",
    title: "Rimontaggio",
    desc: "Posizionamento al millimetro. Vi consegniamo la casa pronta da vivere.",
  },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="relative py-24 lg:py-32 bg-brand-surface overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7 reveal">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
              <span className="w-8 h-px bg-brand-primary" />
              Il metodo
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-ink mt-4 text-balance">
              Cinque passi.<br />
              <span className="text-brand-primary">Zero pensieri per voi.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10 reveal reveal-delay-1">
            <p className="text-lg text-brand-body leading-relaxed">
              Un metodo collaudato in oltre 4.200 traslochi. Strutturato, trasparente, infallibile.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-brand-line" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-3">
            {STEPS.map(({ icon: Icon, n, title, desc }, i) => (
              <div
                key={n}
                data-testid={`process-step-${i}`}
                className={`relative reveal reveal-delay-${(i % 4) + 1}`}
              >
                <div className="relative z-10 w-24 h-24 mx-auto rounded-full bg-white border border-brand-line flex items-center justify-center group hover:border-brand-primary transition-colors">
                  <Icon className="w-9 h-9 text-brand-primary" strokeWidth={1.6} />
                  <span className="absolute -top-2 -right-2 w-9 h-9 rounded-full bg-brand-ink text-white font-display font-bold text-xs flex items-center justify-center">
                    {n}
                  </span>
                </div>
                <div className="mt-6 text-center">
                  <h3 className="font-display font-bold text-xl text-brand-ink">{title}</h3>
                  <p className="text-brand-body mt-2 text-sm leading-relaxed max-w-[220px] mx-auto">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
